/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { ThemedStyleFn, useStyles } from '~src/hooks/useStyles';
import { Spin } from 'antd';

type LoaderProps = {
  withBackgroundOverlay?: boolean;
};

const Loader = ({ withBackgroundOverlay }: LoaderProps) => {
  const style = useStyles(styleFn);

  return (
    <div
      css={Object.assign(
        style.overlay || {},
        withBackgroundOverlay ? style.backgroundOverlay : {}
      )}>
      <Spin size="large" />
    </div>
  );
};

export default Loader;

const styleFn: ThemedStyleFn = () => ({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  backgroundOverlay: {
    background: 'rgba(0,0,0,.15)',
  },
});
